import DummyProvider from '@/services/subscribe/providers/DummyProvider'
import AppSyncProvider from '@/services/subscribe/providers/AppSyncProvider'

export default () => {
  return process.env.VUE_APP_ENABLE_DUMMY_API
    ? new DummyProvider()
    : new AppSyncProvider()
}
